import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Texas = () => {
  return (
    <StatePropertyTaxPage
      stateName="Texas"
      processDescription="Property owners may protest their assessment by filing with the appraisal review board (ARB). Protests must be filed by May 15 (or 30 days after notice if mailed after April 15). The ARB conducts hearings to review evidence and determine fair market value. If unsatisfied with the ARB decision, property owners may appeal to district court or binding arbitration."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Appraisal notices are typically mailed in April, though the deadline for protests is May 15 regardless of mailing date, or 30 days after notice if mailed after April 15."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Texas assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners must file protests by May 15, or within 30 days of receiving the notice if it's mailed after April 15. This deadline is strictly enforced across all Texas counties and appraisal districts."
    />
  );
};

export default Texas;